import React from 'react';
import { createRoot } from 'react-dom/client'; // <- note this import
import './index.css';
import './local';
import './portal.css';
import 'antd/dist/reset.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'mobily-ui-library/style.css';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container); // createRoot replaces ReactDOM.render
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Measuring performance
reportWebVitals();
